import light from './light';
import dark from './dark';

export default {
  light,
  dark,
};
